module.exports = __webpack_public_path__ + "static/img/Frame5.9478b4dc.png";